import React from "react";
import { bgFirst } from "../../constants/colors";
import { Container, Column } from "../../ui-components/columns/components";
import { FullHeightSection } from "../../ui-components/sections";
import { useTranslate } from "../../contexts/translate";

export const CuttingEdgeAnimation = ({ data }) => {
	const { translations } = useTranslate();

	return (
		<FullHeightSection
			className="theme-dark center-in-content masamune-animation"
			style={{ background: bgFirst }}
		>
			<Container className="center">
				<div className="wrapper mid-full align-items-center p-0">
					<Column className="w-100 animation-cutting-edge">
						<div className="we-are text-animation t-center">WE ARE</div>

						<div className="d-block position-relative">
							<div className="item min-text-mobile t-center">
								Cutting-edge
							</div>
						</div>
						<div className="d-block position-relative">
							<div className="item min-text-mobile t-center">
								Digital
							</div>
						</div>
						<div className="d-block position-relative">
							<div className="item min-text-mobile t-center">
								Creative
							</div>
						</div>
						<div className="d-block position-relative">
							<div className="item min-text-mobile t-center">
								Studio
							</div>
						</div>
					</Column>
				</div>
			</Container>
		</FullHeightSection>
	);
};